<template>
  <el-button
    type="default"
    class="back-btn"
    @click="$emit('click')"
  >
    <span class="back-btn__inner">
      <el-icon class="back-btn__icon">
        <Back />
      </el-icon>
      <span class="back-btn__label">{{ label }}</span>
    </span>
  </el-button>
</template>

<script>
import { Back } from '@element-plus/icons-vue'

export default {
  name: 'BackButton',
  components: {
    Back
  },
  props: {
    label: {
      type: String,
      default: '返回'
    }
  }
}
</script>

<style lang="scss" scoped>
.back-btn {
  height: 32px !important;
  padding: 0 16px 0 12px !important;
  margin: 0 !important;
  border: none !important;
  border-radius: 16px !important;
  background: #f4f5f9 !important;
  box-shadow: none !important;
  font-weight: 400;
  font-size: 14px;
  color: #333333 !important;
  transition: all 0.2s ease;

  :deep(.el-button__inner) {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 0 !important;
    gap: 0;
  }
}

.back-btn__inner {
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.back-btn__icon {
  font-size: 16px;
  flex-shrink: 0;
  color: #333333;
  transition: transform 0.2s ease;
}

.back-btn__label {
  letter-spacing: 0;
}

.back-btn:hover,
.back-btn:focus {
  background: #e6e8eb !important;
  color: #333333 !important;

  .back-btn__icon {
    transform: translateX(-2px);
  }
}

.back-btn:active {
  background: #dcdfe6 !important;
  color: #333333 !important;
}

.back-btn:focus-visible {
  outline: 2px solid #dcdfe6;
  outline-offset: 2px;
}
</style>
